import images from './images';

export const abouts = [
  {
    title: 'React Native Developer',
    description: 'Building high-performance, intuitive mobile apps with exceptional UI/UX.',
    image: images.mobile,
  },
  {
    title: 'Web Development',
    description: 'Full-stack web solutions using React, Next.js, Express, and modern tooling.',
    image: images.about04,
  },
  {
    title: 'Backend Engineering',
    description: 'Robust and scalable APIs built with Express.js, Laravel, and MongoDB.',
    image: images.node,
  },
  {
    title: 'Game Development',
    description: 'Immersive gameplay and interactive experiences built with Unity 3D.',
    image: images.unity,
  },
  // {
  //   title: 'Digital Art & Design',
  //   description: 'Creative digital artwork with a strong focus on detail, color, and composition.',
  //   image: images.photoshop,
  // },
];
